// @ts-ignore
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.jsx'
import "./index.css"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('react-target')
)
